import React from 'react';
import Menu from '../../modules/Menu/component';
import SectionSelectorContainer from '../../modules/SectionSelector/container';


const MainPage = () => (
  <div className="main-page">
    <Menu />
    <SectionSelectorContainer />
  </div>
);

export default MainPage;



// WEBPACK FOOTER //
// ./src/pages/main-page/index.js